import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NguCarousel, NguCarouselService, NguCarouselStore} from '@ngu/carousel';
import {Card} from "../../domain/card";
import {CarouselMultipleAction} from "../../domain/card-actions/carousel-multiple.action";
import {ListQuestionComponent} from "../../core/list-question.component";
import {ApiService} from "../../core/api.service";
import {Datasource} from "../../domain/datasource";
import * as JmesPath from 'jmespath';

@Component({
  selector: 'crds-carousel-multiple-form',
  templateUrl: './carousel-multiple-form.component.html'
})
export class CarouselMultipleFormComponent extends ListQuestionComponent implements OnInit, AfterViewInit {

  @Input() form: FormGroup;
  @Input() card: Card<CarouselMultipleAction>;
  public currentMainSlide: number;
  private dynamicCarouselToken: string;
  private mainCarouselToken: string;
  public currentDynamicSlide: number;
  public carouselMain: NguCarousel;
  public carouselDynamic: NguCarousel;
  action: CarouselMultipleAction;
  initialised: boolean = false;

  dynamicSlides = {
    name: '',
    slides: []
  };

  constructor(private carousel: NguCarouselService, protected apiService: ApiService) {
    super(apiService);
  }

  async ngOnInit() {

    this.action = this.card.action;

    if (this.action.datasource) {
      if (!this.action.datasource.transform) {
        this.action.datasource.transform = '[*].{ text: name, name: name, content: description, slides: children[*].{ text: name, name: name, content: description } }';
      }
      await this.getData(this.action.datasource);
    }
    this.initialised = true;

    this.setCurrentMainSlide(this.getCurrentMainSlideFromForm());
    this.setDynamicSlides(this.getCurrentMainSlideName());
    this.updateTargetField(this.getCurrentDynamicSlideFromForm());
    this.carouselMain = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      point: {
        visible: false
      },
      load: 5,
      touch: true,
      loop: false
    };
    this.carouselDynamic = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      point: {
        visible: true
      },
      load: 3,
      touch: true,
      loop: false
    };
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.initialised) {
        this.carousel.moveToSlide(this.mainCarouselToken, this.getCurrentMainSlideFromForm(), false);
        this.carousel.moveToSlide(this.dynamicCarouselToken, this.getCurrentDynamicSlideFromForm(), false);
      }
    });
  }

  mapData(result: any[], datasource: Datasource) {

    const slides: [] = JmesPath.search(result, datasource.transform);

    this.card.action.dynamicSlides = slides;
    this.card.action.mainSlides = slides;
  }

  getSlides(result: any[]) {
    return result.map(item => {
      return {
        text: item.name,
        name: item.name,
        content: item.description,
        slides: item.children && item.children.length > 0 ? this.getSlides(item.children) : []
      };
    });
  }

  getCurrentMainSlideName() {
    return this.card.action.mainSlides[this.currentMainSlide] ?
      this.card.action.mainSlides[this.currentMainSlide].text :
      '';
  }

  getCurrentDynamicSlideName() {
    const currentDynamicSlide = this.card.action.dynamicSlides
      .filter(slide => slide.name === this.getCurrentMainSlideName())[0];
    return currentDynamicSlide.slides[this.currentDynamicSlide] ?
      currentDynamicSlide.slides[this.currentDynamicSlide].text :
      '';
  }

  setCurrentMainSlide(slide: number) {
    this.currentMainSlide = slide;
  }

  setCurrentDynamicSlide(slide: number) {
    this.currentDynamicSlide = slide;
  }

  setCurrentDynamicSlideName(name: string) {
    this.dynamicSlides.name = name;
  }

  setDynamicSlides(mainSlideName: string) {
    this.setCurrentDynamicSlideName(mainSlideName);
    const currentDynamicSlide = this.card.action.dynamicSlides
      .filter(slide => slide.name === this.getCurrentMainSlideName())[0];
    this.dynamicSlides.slides = Object.assign([], currentDynamicSlide.slides);
  }

  updateMainSlide(currentSlide: number) {
    if (currentSlide !== this.currentMainSlide) {
      this.carousel.reset(this.dynamicCarouselToken);
      this.setCurrentMainSlide(currentSlide);
      this.setCurrentDynamicSlide(0);
      this.setDynamicSlides(this.getCurrentMainSlideName());
      this.updateTargetField(0);
    }
  }

  updateTargetField(currentSlide: number) {
    this.setCurrentDynamicSlide(currentSlide);
    setTimeout(() => {
      this.form.get(this.action.targetField).patchValue(
        this.getCurrentMainSlideName() + ' - ' + this.getCurrentDynamicSlideName()
      );
    });
  }

  initMainCarousel(key: NguCarouselStore) {
    this.mainCarouselToken = key.token;
  }

  initDynamicCarousel(key: NguCarouselStore) {
    this.dynamicCarouselToken = key.token;
  }

  private getCurrentMainSlideFromForm() {
    const currentFormValue = this.form.get(this.action.targetField).value;
    if (!currentFormValue) {
      return 0;
    }
    const currentMainSlideValue = currentFormValue.split(' - ')[0];
    return this.card.action.mainSlides.findIndex(mainSlide => mainSlide.text === currentMainSlideValue);
  }

  private getCurrentDynamicSlideFromForm() {
    const currentFormValue = this.form.get(this.action.targetField).value;
    if (!currentFormValue) {
      return 0;
    }
    const currentDynamicSlideValue = currentFormValue.split(' - ')[1];
    return this.dynamicSlides.slides.findIndex(dynamicSlide => dynamicSlide.text === currentDynamicSlideValue);
  }
}
